import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { ProjectGetDetailsById, ProjectGetDetailsByIdResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<ProjectGetDetailsByIdResponse, ProjectGetDetailsByIdResponse>) => {
    return response?.data;
}
const getError = (response?: SWRResponse<ProjectGetDetailsByIdResponse, ProjectGetDetailsByIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<StageGetSummaryCollectionByProjectIdResponse, StageGetSummaryCollectionByProjectIdResponse>) => ({});

const useProjectDetailsById = (projectId: number, configuration?: SWRConfiguration<ProjectGetDetailsByIdResponse, ProjectGetDetailsByIdResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new ProjectGetDetailsById({
                projectId: projectId
            });
        };
    }, [projectId])

    return useGet(request, { getData, getError }, configuration);
}

export default useProjectDetailsById;